import { css, createGlobalStyle } from "styled-components";

enum ColorPalette {
  black = "#000000",
  darkGrey = "#222126",
  midGrey = "#6b6261",
  midGreyAlt = "#dad0cf",
  lightGrey = "#efeaea",
  white = "#FFFFFF",
  red = "#d61130",
  darkRed = "rgba(136, 11, 28, 0.9)",
  darkBlue = "rgba(37, 15, 123, 0.9)",
  lightGreen = "#97d8e4",
  green = "#1898af",
  darkGreen = "rgba(3, 88, 105, 0.9)",
}
enum BreakPoints {
  xs = "0",
  sm = "+300",
  md = "+501",
  lg = "+750",
  xl = "+960",
}

export const theme = {
  colors: {
    ...ColorPalette,
    bg: ColorPalette.white,
    fg: ColorPalette.black,
    accent: ColorPalette.red,
    neutral: ColorPalette.midGrey,
    bgAccent: ColorPalette.lightGrey,
    midGrey: ColorPalette.midGrey,
    midGreyAlt: ColorPalette.midGreyAlt,
    darkRed: ColorPalette.darkRed,
    darkBlue: ColorPalette.darkBlue,
    darkGreen: ColorPalette.darkGreen,
  },
  font: "Gill-Sans",
  poi: {
    site: ColorPalette.darkRed,
    story: ColorPalette.darkBlue,
    event: ColorPalette.darkGreen,
  },
  breakpoints: BreakPoints,
};
export type Theme = typeof theme;

declare module "styled-components" {
  export interface DefaultTheme extends Theme {}
}

export const buttonReset = css`
  outline: none;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  width: auto;
`;

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Gill-Sans';
    src: url('/assets/fonts/gill-sans-light.woff') format('woff');
    font-weight: normal;
  }

  @font-face {
    font-family: 'Gill-Sans';
    src: url('/assets/fonts/gill-sans-book.woff') format('woff');
    font-weight: 500;
  }

  @font-face {
    font-family: 'Gill-Sans';
    src: url('/assets/fonts/gill-sans-medium.woff') format('woff');
    font-weight: 600;
  }


  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure, 
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  * {
    overscroll-behavior: none;
  }
  body {
    position: fixed;
    overscroll-behavior: none;
    background: #f4f4f4;

    background-repeat: repeat;
    /* Disables pull-to-refresh but allows overscroll glow effects. */
    overscroll-behavior-y: contain;
    position: absolute;
    overflow: hidden;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    width: 100%;
    backface-visibility: hidden;
    transform-style: preserve-3d;
    font-family: 'Gill-Sans';
  }
  input, textarea {
    font-family: 'Gill-Sans';
  }
  em {
    font-style: italic;
  }
`;
